import LineInterface from 'app/interfaces/LineInterface';

export const extractNumericValue = (line: LineInterface): number => {
    const numberRegex = (/(?<integer>\d+)(?<fraction>\.\d+)?/u);
    const match = line.gamer_1.nick.match(numberRegex);
    return match ? parseFloat(match[0]) : 0;
};
